export interface GLCodeProps {
  glCodeId: number;
  glCode: string;
  glCodeDescription: string;
  displayName: string;
}

export class GLCode {
  private readonly _glCodeId: number;
  private readonly _glCode: string;
  private readonly _glCodeDescription: string;
  private readonly _displayName: string;

  constructor(props: GLCodeProps) {
    this._glCodeId = props.glCodeId;
    this._glCode = props.glCode;
    this._glCodeDescription = props.glCodeDescription;
    this._displayName = props.displayName;
  }

  public get glCodeId(): number {
    return this._glCodeId;
  }

  public get glCode(): string {
    return this._glCode;
  }

  public get glCodeDescription(): string {
    return this._glCodeDescription;
  }

  public get displayName(): string {
    return this._displayName;
  }
}
